import React, { ChangeEvent, JSX, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Card, Empty, Form, Input, Modal, Spin, Typography, Tooltip } from 'antd';
import { SmileOutlined, FolderOpenOutlined, LoadingOutlined, InfoCircleOutlined } from '@ant-design/icons';
// import { Modal, message } from 'antd';
// import { Grid,Paper, Avatar, TextField, Button, Typography, Link, FormControlLabel } from @mui/material'
// import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { Button, Col, Row, } from 'antd';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './IPwhitelist.scss';
import AadharImg from './aadhar.png.png';
import * as Yup from 'yup';
import { Breadcrumb, Layout, Menu, theme, } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { BackendAPI } from '../../../axios';
import UserHeader from '../UserHeader';
import UserNavbar from '../UserNavbar';
import { Footer } from 'antd/es/layout/layout';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
const { Header, Content, Sider } = Layout;
const { Title } = Typography;
const THEME_COLOR = "#1515b4";

const MySwal = withReactContent(Swal);

interface PageSettingsProps {
    isDarkMode: boolean;
}
interface WhitelistRequest {
    ip: string;
    // status: string;
    // whitlist_timestamp: string;
}
interface CustomModalProps {
    ip: string;
    visible: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}
const CustomModal: React.FC<CustomModalProps> = ({ ip, visible, onClose, onConfirm }) => {
    return (
        <Modal
            open={visible}
            footer={null}
            onCancel={onClose}
            closable={false}
            style={{
                // display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0, // Custom padding
            }}
        >
            <div
            >
                <Typography
                    style={{
                        fontWeight: 600,
                        fontSize: '20px',
                        color: '#333',
                        textAlign: 'center',
                        marginBottom: 2,
                        fontFamily: '"Roboto", sans-serif',
                    }}
                >
                    Are you sure you want to delete this IP?
                </Typography>
                <Typography
                    style={{
                        textAlign: 'center',
                        color: '#555',
                        marginBottom: 3,
                        fontSize: '16px',
                        fontFamily: '"Roboto", sans-serif',
                    }}
                >
                    This action will permanently remove the
    <span style={{ fontWeight: 'bold', color: '#da380aff' }}> IP: {ip} </span>
    from the whitelist.
</Typography>
                <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="primary" danger onClick={onClose}
                        style={{
                            marginRight: '10px',
                            backgroundColor: '#f0f0f0',
                            color: '#e8391a',
                            fontWeight: 600,
                            borderRadius: 4,
                            textTransform: 'none',
                            padding: '10px 20px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            (e.target as HTMLButtonElement).style.backgroundColor = '#f5f5f5';
                        }}
                        onMouseLeave={(e) => {
                            (e.target as HTMLButtonElement).style.backgroundColor = '#f0f0f0';
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        color='danger'
                        onClick={async () => {
                            await onConfirm();
                            onClose(); // Close modal after confirmation
                        }}
                        style={{
                            // backgroundColor: '#e8391a',
                            // color: '#fff',
                            fontWeight: 600,
                            borderRadius: 4,
                            textTransform: 'none',
                            padding: '10px 20px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            (e.target as HTMLButtonElement).style.backgroundColor = '#ff4500';
                        }}
                        onMouseLeave={(e) => {
                            (e.target as HTMLButtonElement).style.backgroundColor = '#ff6347';
                        }}
                    >
                        Yes, Delete
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

function IPwhitelist(): JSX.Element {
    const [inputValue, setInputValue] = useState<string>('');
    const [deleteIP, setDeleteIP] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [error1, setError1] = useState<string | null>(null);
    const [showInstructions, setShowInstructions] = React.useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [isOnClickSlider, setOnclickSlider] = useState(false)
    const [data, setData] = useState<WhitelistRequest[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [ipToDelete, setIpToDelete] = useState('');
    const [loadings, setLoadings] = useState<boolean[]>([]);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 830);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        ipvalue: Yup.string().required('IP Address is required'),
    });

    const { control, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });
    const onSubmit = async (data: any) => {
        setLoading(true);
        console.log("Form Data:", data);
        if (data.ipvalue.trim().length == 0) {
            setError("This field is required");
            return;
        }
        await getRefreshToken();
        const url = `/ip/save`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
            params: {
                ip: `${data.ipvalue.trim()}`,
            },
        };
        try {
            const response = await BackendAPI.post(url, {}, header);
            const errorMessage = response.data.replace(/^Error:\s*/, "");

            switch (errorMessage) {
                case "IP is already in use":
                    MySwal.fire({
                        icon: 'error',
                        title: 'Duplicate IP Detected',
                        text: "The entered IP address is already in use. Please use a different one.",
                    });
                    break;

                case "Maximum allowed IP limit exceeded":
                    MySwal.fire({
                        icon: 'error',
                        title: 'IP Limit Reached',
                        text: "You have reached the maximum limit of 7 IP addresses. Remove an existing IP to add a new one.",
                    });
                    break;

                case "Successfully saved IP":
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: "The whitelisted IP request has been processed successfully.",
                    }).then(() => {
                        // window.location.reload();
                        fetchData();
                    });
                    break;

                default:
                    MySwal.fire({
                        icon: 'error',
                        title: 'Unexpected Error',
                        text: "An unexpected error occurred. Please try again later.",
                    });
                    break;
            }
            setLoading(false);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    handleLogout();
                }
            }
            MySwal.fire({
                icon: 'error',
                title: 'Unexpected Error',
                text: "An unexpected error occurred. Please try again later.",
            });
            setLoading(false);
        }
    };

    const showIpDeleteModal = (ip: string, index: number) => {
        setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = true;
            return newLoadings;
        });
        setIpToDelete(ip);
        setIsModalVisible(true);
    };
    const handleLogout = async () => {
        try {
            const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

            if (response.status === 200) {
                localStorage.removeItem("authToken");
                localStorage.removeItem("initialTime");
                localStorage.removeItem("lastSavedTime");
                localStorage.removeItem("remainingTime");
                navigate("/");
            }
        } catch (error) {
        }
    };
    const handleSubmitDeleteIP = async () => {
        setLoading(true);
        if (ipToDelete.trim().length == 0) {
            setError1("This field is required");
            setLoading(false);
            return;
        }
        await getRefreshToken();
        const url = `/ip/delete`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
            params: {
                ip: `${ipToDelete.trim()}`,
            },
        };
        try {
            const response = await BackendAPI.delete(url, header);
            const errorMessage = response.data.replace(/^Error:\s*/, "");
            switch (errorMessage) {
                case "IP not found":
                    MySwal.fire({
                        icon: 'error',
                        title: 'Error: IP Not Found',
                        text: "The specified IP address could not be found in our records.",
                    });
                    break;

                case "Associated user not found":
                    MySwal.fire({
                        icon: 'error',
                        title: 'Error: User Not Found',
                        text: "No user is associated with this IP address.",
                    });
                    break;

                case "Whitelisted IP deletion request processed successfully":
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: "The whitelisted IP deletion request has been processed successfully.",
                    }).then(() => {
                        // window.location.reload();
                        fetchData();
                    });
                    break;

                case "Failed to send deletion email":
                    MySwal.fire({
                        icon: 'error',
                        title: 'Email Sending Failed',
                        text: "We were unable to send the deletion confirmation email. Please try again later.",
                    });
                    break;

                case "Failed to delete IP":
                    MySwal.fire({
                        icon: 'error',
                        title: 'IP Deletion Failed',
                        text: "An error occurred while trying to delete the IP address. Please try again.",
                    });
                    break;

                default:
                    MySwal.fire({
                        icon: 'error',
                        title: 'Unexpected Error',
                        text: "Something went wrong. Please try again later or contact support.",
                    });
                    break;
            }
            setLoading(false);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    handleLogout();
                }
            }
            MySwal.fire({
                icon: 'error',
                title: 'Unexpected Error',
                text: "An unexpected error occurred. Please try again later.",
            });
            setLoading(false);
        }
    };
    const handleCollapse = (value: any) => {
        setCollapsed(value);
        setOnclickSlider(!isOnClickSlider);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        setError(null);
    };
    const handleInputChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDeleteIP(event.target.value);
        setError1(null);
    };

    let refreshToken: null = null;
    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
            refreshToken = response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    window.location.reload();
                }
            }
        }
    };

    const labelStyle = {
        fontSize: "16px",
        color: "#000000", // White for dark mode, black for light mode
        fontWeight: "bold",
        // marginBottom: "8px",
    };

    const fetchData = async () => {
        await getRefreshToken()
        const url = `/ip/list`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };
        try {
            const response = await BackendAPI.get(url, header);
            setData(response.data);
            const tableBody = document.getElementById('table-body');
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    handleLogout();
                }
            }
            MySwal.fire({
                icon: 'error',
                title: 'Unexpected Error',
                text: "An unexpected error occurred. Please try again later.",
            });
        }
    }
    useEffect(() => {
        fetchData();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 830);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            {loading && (
                <Spin spinning={true} style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 9999 }} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            )}
            {/* <div>
                <UserHeader setIsOnClickSlider={setOnclickSlider} />
            </div> */}
            <Layout style={{ minHeight: '89vh', }}>

                <Sider
                    // collapsed={isOnClickSlider}
                    collapsed={isMobile ? true : isOnClickSlider}
                    // trigger={null} // disable default trigger
                    // collapsible
                    collapsedWidth={50}
                    // onCollapse={handleCollapse}
                    style={{
                        // height: '90vh',
                        background: 'white',
                        position: 'relative',
                        overflow: 'auto',
                        top: '0px',
                        paddingTop: '20px',
                    }}
                >
                    {/* Custom collapse icon at top */}

                    <div style={{ top: '0', position: 'sticky', height: '100%', }}>
                        {/* Add menu or other content here */}
                        {/* <div
                            style={{
                                position: 'absolute',
                                top: 0, textAlignLast: 'right',
                                cursor: 'pointer', width: '100%', padding: '6px 16px',
                            }}
                            onClick={handleCollapse}
                        >
                            {collapsed ? <MenuUnfoldOutlined style={{ fontSize: '30px', }} /> : <MenuFoldOutlined style={{ fontSize: '30px', }} />}
                        </div> */}
                        <UserNavbar />
                        {/* <div style={{ textAlignLast: 'center', transition: 'all 0.9s', display: isOnClickSlider ? 'none' : 'block', position: 'absolute', justifySelf: 'center', bottom: '2%', }}>
                            <img src={cdac_logo} alt="Status" style={{ width: '40%', height: 'auto' }} />
                            <h5 style={{ textAlign: 'center', margin: '0' }}>Center for Development of Advanced Computing (C-DAC)</h5>
                        </div> */}
                    </div>
                </Sider>
                <Layout>
                    <Content style={{ margin: '16px 16px 0' }}>
                        <div style={{ width: '100%', justifyItems: 'center', marginTop: '40px', }}>
                            {/* <Box style={{
                            width: '90%',
                            justifyItems: 'center',
                            border: '2px solid #2c56ff',
                        }}> */}
                            <Row gutter={24} style={{ minWidth: '100%' }}>
                                {/* Input 1 */}
                                <Col xs={24} md={12}>
                                    <div className='table-container' style={{ backgroundColor: '' }}>
                                        {/* <h1>IP Whitelisting</h1> */}
                                         <Title
                                    level={3}
                                    style={{
                                        color: THEME_COLOR,
                                        borderBottom: `3px solid ${THEME_COLOR}`,
                                        display: "inline-block",
                                        paddingBottom: 6,
                                        marginBottom: 32,
                                    }}
                                >
                                    IP Whitelisting
                                </Title>
                                        <Card style={{ padding: '10px' }}>
                                            


                                            <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
                                                <Form.Item
                                                    label={
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            gap: '12px',
                                                            width: '100%',
                                                        }}>
                                                            <span style={labelStyle}>IP Address</span>
                                                            <Tooltip
                                                                title={
                                                                    <React.Fragment>
                                                                        <Typography style={{ fontWeight: 'bold', color: '#fff' }}>
                                                                            Instructions:
                                                                        </Typography>
                                                                        <Typography style={{ fontSize: 'small', color: '#fff' }}>
                                                                            Entries more than 6 IPs are not allowed
                                                                        </Typography>
                                                                    </React.Fragment>
                                                                }
                                                                placement="topLeft"
                                                            >
                                                                <span
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        marginLeft: '190px',
                                                                        width: 'max-content'
                                                                    }}
                                                                >
                                                                    <InfoCircleOutlined style={{ marginRight: '6px' }} />
                                                                    <Typography
                                                                        style={{
                                                                            textDecoration: 'underline',
                                                                            fontSize: '12px'
                                                                        }}
                                                                    >
                                                                        Instructions
                                                                    </Typography>
                                                                </span>
                                                            </Tooltip>
                                                        </div>
                                                    }
                                                >
                                                    <Controller
                                                        name="ipvalue"
                                                        control={control}
                                                        render={({ field }) => <Input {...field} placeholder='Enter IP Address' />}
                                                    />
                                                </Form.Item>

                                                {(touchedFields.ipvalue || isSubmitted) && errors.ipvalue && (
                                                    <div style={{ color: '#ff4d4f', marginTop: '-12px', marginBottom: '0px', fontSize: '14px' }}>
                                                        {errors.ipvalue.message}
                                                    </div>
                                                )}
                                                <Button type="primary" htmlType="submit" style={{ width: '60%', background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)', alignSelf: 'center', marginTop: '10px', fontSize: '16px' }}>
                                                    Request for Whitelist
                                                </Button>
                                            </Form>
                                        </Card>
                                    </div>
                                </Col>
                                {/* Input 2 */}
                                <Col xs={24} md={12}>
                                    <div className="table-container" style={{ backgroundColor: '' }}>
                                        {/* <h1>Whitelisted IPs</h1> */}
                                         <Title
                                    level={3}
                                    style={{
                                        color: THEME_COLOR,
                                        borderBottom: `3px solid ${THEME_COLOR}`,
                                        display: "inline-block",
                                        paddingBottom: 6,
                                        marginBottom: 32,
                                    }}
                                >
                                    Whitelisted IPs
                                </Title>
                                        <table id="whitelist-table" style={{ backgroundColor: '' }}>
                                            {/* <thead>
                                        <tr>
                                            <th>Whitelisted IP</th>
                                        </tr>
                                    </thead> */}
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td style={{ color: '' }}>{item.ip}</td>
                                                        <td>
                                                            {/* <Button onClick={() => handleSubmitDeleteIP(item.ip)}><DeleteOutlined /></Button> */}
                                                            <Button type="primary" danger onClick={() => showIpDeleteModal(item.ip, index)} >
                                                                Delete IP
                                                            </Button>
                                                            <CustomModal
                                                                ip={ipToDelete}
                                                                visible={isModalVisible}
                                                                onClose={() => setIsModalVisible(false)}
                                                                onConfirm={handleSubmitDeleteIP}
                                                            />
                                                        </td>

                                                    </tr>
                                                ))}
                                                {data.length === 0 ? (
                                                    <Empty
                                                        description="No IP addresses are currently whitelisted."
                                                    />
                                                ) : ''}
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>

                            {/* </Box> */}
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>
                        ©2025 Copyright: C-DAC Mumbai. All Rights Reserved
                    </Footer>
                </Layout>
            </Layout>
        </>
    );
}

export default IPwhitelist;

